import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15 2C7.82 2 2 7.82 2 15s5.82 13 13 13 13-5.82 13-13S22.18 2 15 2m6.026 8.841c-.195 2.055-1.043 7.044-1.473 9.346-.182.975-.541 1.301-.888 1.332-.755.07-1.328-.499-2.06-.978-1.144-.75-1.79-1.216-2.9-1.949-1.284-.846-.452-1.31.279-2.07.192-.2 3.517-3.225 3.582-3.5.008-.034.017-.162-.06-.229s-.189-.044-.269-.026q-.172.039-5.484 3.624-.779.534-1.41.521c-.464-.01-1.357-.262-2.02-.479-.814-.264-1.462-.405-1.406-.853q.044-.351.967-.719 5.685-2.476 7.58-3.266c3.612-1.501 4.361-1.763 4.85-1.771.614-.009.761.497.712 1.017",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "telegram"}) } }